import {
  error,
  money,
  tabaPayError,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const TabaPayChallengeAuthenticate = gql`
  mutation TabaPayChallengeAuthenticate(
    $input: TabaPayChallengeAuthenticateInput!
  ) {
    tabaPayChallengeAuthenticate(input: $input) {
      ... on TabaPayChallengeAuthenticateResultSuccess {
        transactionID
        __typename
      }
      ... on TabaPayChallengeAuthenticateResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
      ... on TabaPayPartialAuth {
        partialAuthTitle: title
        partialAuthMessage: message
        statusCode
        approvedAmount {
          ...money
        }
        actions {
          buttonText
          buttonStyle
          id
          buttonOnClick {
            __typename
            ... on SDContinueClientFlowAction {
              __typename
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
  ${money}
  ${AnalyticsEventFragment}
`;

export default TabaPayChallengeAuthenticate;
